'use strict';

function DialogViewDirective () {
  
  function link (scope, $el, attrs, ctrls) {
    var autofocus = attrs.autofocus && !!attrs.autofocus.match(/^(true)$/gi);
    var inputEl = null;

    // grab the controllers
    var dialogCtrl = ctrls[0]; // parent controller
    var viewCtrl = ctrls[1]; // individual view controller

    // get the group
    var dialogId = dialogCtrl.getId();

    // initialize
    viewCtrl.init(dialogId);

    // if autofocus... cache the first child input element and watch for the view to open
    if (autofocus) {
      if (!inputEl) {
        inputEl = $el.find('input')[0];
      }

      scope.$watch(viewCtrl.watchShow(), function (show) {
        if (show) {
          inputEl.focus();
        }
      });
    }
  }

  return {
    bindToController: true,
    controller: 'sbDialogViewController',
    controllerAs: 'dialogViewCtrl',
    link: link,
    require: ['^sbDialog', 'sbDialogView'],
    scope: {
      autofocus: '@', // {boolean} auto focus on the first input element
      id: '@sbDialogView', // {string} view id
      title: '@', // {string}
      subtitle: '@' // {string}
    },
    templateUrl: 'saturn/dialog/dialogView/dialogView.tpl.html',
    transclude: true
  };
}

module.exports = DialogViewDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dialog/src/dialogView/DialogViewDirective.js